module.exports = __webpack_public_path__ + "7d3f8f4581b5a40a1c97f7cab8128656.jpg";